/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAccessTokenRequest } from '../models/GetAccessTokenRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ZendeskService {

    /**
     * Revokes the Zendesk access token on behalf of an user.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns any OK
     * @throws ApiError
     */
    public static revokeAuthorizationToken(
        organizationId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/organizations/{organizationId}/zendesk/revokeAuthToken',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the Zendesk integration.
     * @param requestBody The request
     * @returns any OK
     * @throws ApiError
     */
    public static callBackAuthentication(
        requestBody?: GetAccessTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/zendesk/getAccessToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
